<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/PushInfo/select"
      :model="formModel"
      :submitData="submitData"
      :show="false"
      :submitService="submitService"
      @success="onSuccess"
      :goback="true"
    >
      <el-form-item label="电话号码">
        <el-input
          type="text"
          maxlength="20"
          placeholder="请输入电话号码"
          v-model="formModel.phone"
        ></el-input>
      </el-form-item>
    </common-top-form>
    <div class="flex-row vertical-center push-range">
      <p class="tat-title">发送范围：</p>
      <p v-if="pushRangeName == 1">普通短信</p>
      <p v-else-if="pushRangeName == 2">按范围</p>
      <p v-else-if="pushRangeName == 3">按等级</p>
      <p v-else-if="pushRangeName == 4">按系统</p>
    </div>
    <div class="flex-row vertical-center push-range-num">
      <p>统计：</p>
      <el-radio-group v-model="type">
        <el-radio label="">总数：{{ statistics.totalCount }}</el-radio>
        <el-radio label="1">成功：{{ statistics.succCount }}</el-radio>
        <el-radio label="0">失败：{{ statistics.failCount }}</el-radio>
      </el-radio-group>
    </div>
    <common-table
      :data="tableData"
      ref="commonTable"
      @handleChange="getPushList"
    >
      <el-table-column prop="phone" label="电话号码"></el-table-column>
      <el-table-column prop="sendStatus" show-overflow-tooltip label="状态">
        <template slot-scope="scope">
          <p>{{ scope.row.sendStatus == 1 ? "成功" : "失败" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="sendTime"
        show-overflow-tooltip
        label="发送时间"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTable from "components/common/CommonTable";
import CommonTopForm from "components/common/CommonTopForm";

import OrganService from "service/OrganService";
import APPService from "service/APPService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "PushInfo",
  data() {
    return {
      radio: "",
      pushRangeName: "",
      type: "",
      statistics: {},
      newType: "",
      tableData: [],
      page: {},
      formModel: {
        phone: "",
      },
      submitService: APPService.getList,
      taskId: "",
    };
  },
  mounted() {
    // this.pushRangeName = '19c42bc892934ad6a41cf51702f8eb17';
    this.pushRangeName = this.$route.params.pushRange;
    this.taskId = this.$route.params.id;
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.getPushList();
  },
  components: {
    CommonTable,
    CommonTopForm,
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        taskId: this.taskId,
        smsStatus: this.newType,
        current: this.page.currentPage,
        size: this.page.pageSize,
        phone: this.formModel.phone.trim(),
      };
      return params;
    },
    ...mapGetters(["userId"]),
  },
  watch: {
    type(val) {
      this.newType = val;
      this.getPushList(val);
    },
  },
  methods: {
    getList() {
      const params = {
        taskId: this.taskId,
      };
      this.doLoad(
        APPService.getStatisCount,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.statistics = result;
          });
        },
        "信息获取失败"
      );
    },
    getPushList() {
      this.doLoad(
        APPService.getList,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
  },
};
</script>

<style scoped>
.push-range p,
.push-range-num p {
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  margin-right: 10px;
}
.tat-title {
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}
.push-range-num {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/PushInfo.vue